import React, { createContext, useContext, useEffect, useRef, useState } from "react";
import SpeakerManager from "../../Managers/Speakers";

const OUR_EXPERT_ITEM_PER_PAGE = 20;

const OurExpertsContext = createContext();

export const useOurExperts = () => useContext(OurExpertsContext);
const DEFAULT_SPECIALTY = "default"; // Change as needed

const OurExpertsProvider = ({ children }) => {
  const [speakersBySpecialty, setSpeakersBySpecialty] = useState({});
  const [currentSpecialty, setCurrentSpecialty] = useState(null);

  const fetchSpeakersData = async (specialty) => {
    let res = await SpeakerManager._get.getSpeakersFromBackstage(specialty);
    return res.data || [];
  };

  const getSpeakersData = async (specialty) => {
    let speakers = await fetchSpeakersData(specialty);
    let usedSpecialty = specialty;
    // console.log("defaultSpeakers", speakers)
    // fetch and merge default speakers (avoid duplicates)
    if (specialty !== DEFAULT_SPECIALTY) {
      const defaultSpeakers = await fetchSpeakersData(DEFAULT_SPECIALTY);
      // Merge, avoiding duplicates by id (assuming speaker.id is unique)
      const merged = [
        ...speakers,
        ...defaultSpeakers.filter(
          (ds) => !speakers.some((s) => s.id === ds.id)
        ),
      ];
      speakers = merged;
    }

    // If still empty, fallback to default specialty
    if (!speakers.length && specialty !== DEFAULT_SPECIALTY) {
      speakers = await fetchSpeakersData(DEFAULT_SPECIALTY);
      usedSpecialty = DEFAULT_SPECIALTY;
    }

    setSpeakersBySpecialty((prev) => ({
      ...prev,
      [usedSpecialty]: {
        allSpeakers: speakers,
        dataToBeRender: speakers.slice(0, OUR_EXPERT_ITEM_PER_PAGE),
        page: 1,
      },
    }));
    setCurrentSpecialty(usedSpecialty);
  };

  const loadMoreSpeakers = (specialty) => {
    setSpeakersBySpecialty((prev) => {
      const data = prev[specialty];
      if (!data) return prev;
      const nextPage = data.page + 1;
      const newData = [
        ...data.dataToBeRender,
        ...data.allSpeakers.slice(
          data.page * OUR_EXPERT_ITEM_PER_PAGE,
          nextPage * OUR_EXPERT_ITEM_PER_PAGE
        ),
      ];
      return {
        ...prev,
        [specialty]: {
          ...data,
          dataToBeRender: newData,
          page: nextPage,
        },
      };
    });
  };

  // For "view all" just use speakersBySpecialty[currentSpecialty]?.allSpeakers

  return (
    <OurExpertsContext.Provider
      value={{
        getSpeakersData,
        loadMoreSpeakers,
        speakersBySpecialty,
        currentSpecialty,
      }}
    >
      {children}
    </OurExpertsContext.Provider>
  );
};

export default OurExpertsProvider;
